const scrollToId = (id: string) => {
  const el: any = document.getElementById(id)
  if (el) {
    el.scrollIntoView({block: 'start', behavior: 'smooth'})
  }
}

export default scrollToId
